import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { model as router } from '!/router'
import { genPagesLogic } from '@/effector'
import { nay, T } from '@/helpers'
import { api } from '@setplex/tria-api'
import { combine, createEvent, restore, sample, type Store } from 'effector'
import { not } from 'patronum'
import {
  formatCategoriesWithShows,
  formatTvShowCategoryWithName,
  type CategoryWithShowsFormatted,
  type TvShowCategoryFormatted,
} from '~/entities/shows/categories'
import '~/entities/shows/model'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import '~/shared/ui/translations/general-translations'

const DEFAULT_ROWS_COUNT = 9

// *
// * EVENTS
// *

export const initShowSubCategories = createEvent<{ categoryId: number }>()
export const left = createEvent()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

// *
// * STORES
// *

export const $category: Store<TvShowCategoryFormatted | null> = combine(
  api.tvshows.$parentCategoryShows,
  i18n.$t,
  (category, { t }) => formatTvShowCategoryWithName({ category, t })
)

export const seeAllTvShowClick = createEvent<{ id: number }>()
export const $shows: Store<CategoryWithShowsFormatted[] | null> = combine(
  api.tvshows.$subCategoriesWithShows,
  ssePurchasesModel.$tvShow,
  i18n.$t,
  (categories, adjust, { t }) =>
    formatCategoriesWithShows({ categories, adjust, t })
)

// *
// * CONNECTIONS
// *

sample({
  clock: initShowSubCategories,
  filter: not(api.tvshows.initShowsSubCategoriesFx.pending),
  fn: ({ categoryId }) => ({ categoryId, page: 0, count: DEFAULT_ROWS_COUNT }),
  target: api.tvshows.initShowsSubCategoriesFx,
})

sample({
  clock: seeAllTvShowClick,
  fn: ({ id }) => `/content/series/categories/${id}`,
  target: router.navigatePush,
})

/********** Skeleton logics starts ***********/

sample({
  clock: initShowSubCategories,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.tvshows.initShowsSubCategoriesFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

const loadMoreShows = genPagesLogic(
  api.tvshows.$pageInfoSubCategoriesWithShows,
  api.tvshows.loadSubCategoriesWithShowsFx
)

// *
// * SKIN
// *

// clear paginatable stores
api.tvshows.$subCategoriesWithShows.reset(initShowSubCategories)

register($shows, '$shows/categories/categoryId/subcategories/shows')
register($category, '$shows/categories/categoryId/subcategories/category')
register(seeAllTvShowClick, 'shows/index/seeAll')
register(loadMoreShows, 'loadMoreShows')
